import { zipcodes } from '../api/zipcodes';

const findZipcode = (form) => zipcodes.some((zipcode) => form.zipcode === zipcode);

export default function validate(form) {
  let allErrors = {};
  let allValidFields = {};

  const regexNumber = /^[0-9]*$/;

  if (!form.zipcode.trim()) {
    allErrors.zipcode = 'Necesitamos el código postal para continuar';
  } else if (form.zipcode.trim().length < 4 && regexNumber.test(form.zipcode.trim())) {
    allErrors.zipcode = 'El código postal debe tener 4 números';
  } else if (!regexNumber.test(form.zipcode.trim())) {
    allErrors.zipcode = 'El código postal sólo puede tener números';
  } else if (findZipcode(form) === false) {
    allErrors.zipcode = 'El código postal no es correcto';
  } else {
    allValidFields.zipcode = true;
  }

  return { allErrors, allValidFields };
}
